import { Flex, Tag } from 'antd';
import { PropsWithChildren } from 'react';

const NewFeatureRow = ({ children }: PropsWithChildren) => (
  <Flex gap={8} justify="space-between">
    {children}
    <Tag color="warning">NOVO</Tag>
  </Flex>
);

export default NewFeatureRow;
